export const TEST_MAGNUM_GO_PARAMETERS = [
  {
    token: 'abc',
    caseId: '1',
    url: 'https://magnum.go',
  },
];
